import React from "react";
import Nav from "../../components/shared/Nav/Nav";
import Footer from "../../components/shared/Footer/Footer";
import { Helmet } from "react-helmet";
import Banner from "../../components/pages/Signup/Banner/Banner";
import { ReactComponent as LogoIcon } from "../../assets/shared/logo.svg";

const Signup = () => {
  return (
    <div className="signup-page">
      <Helmet>
        <title>Signup to Adgate</title>
      </Helmet>
      <Nav styles="nav__white" logo={<LogoIcon />} stickyColors />
      <Banner />
      <Footer />
    </div>
  );
};

export default Signup;
